




































































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import firebase from 'firebase';
import { User } from '@/models/user';

@Component
export default class UsersComponent extends Vue {
    private email = '';
    private password = '';
    private firstName = '';
    private lastName = '';

    private currentlyEditingUserRef = '';

    private usersRef = firebase.firestore().collection('users');

    private headers = [
        {
            text: 'Email',
            value: 'email',
            align: 'center',
        },
        {
            text: 'First Name',
            value: 'firstName',
            align: 'center',
        },
        {
            text: 'Last Name',
            value: 'lastName',
            align: 'center',
        },
    ];

    private currentUsers: any[] = [];

    private isAddVisible = false;
    private isEditVisible = false;

    // This is a hack so that the currently signed in user doesn't change when creating a user
    private adminFirebase = firebase.apps.find((appl) => appl.name === 'Admin') || firebase.apps[0];

    private created(): void {
        this.updateUsers();
    }

    private submit(): void {
        this.adminFirebase.auth().createUserWithEmailAndPassword(this.email, this.password)
            .then(() => {
                this.usersRef.add(
                    {
                        email: this.email,
                        firstName: this.firstName,
                        lastName: this.lastName,
                    },
                ).then(() => {
                    this.updateUsers();
                    this.resetForm();
                    this.adminFirebase.auth().signOut();
                    this.isAddVisible = false;
                });
            })
            .catch((err: any) => {
                alert('Oops: ' + err.message);
            });
    }

    private submitEdit(): void {
        const doc = this.usersRef.doc(this.currentlyEditingUserRef);
        if (doc) {
            doc.update({
                firstName: this.firstName,
                lastName: this.lastName,
            }).then(() => {
                this.isEditVisible = false;
                this.resetForm();
                this.updateUsers();
            })
            .catch((err) => alert('Something has gone wrong: ' + err.message));
        }
    }

    private updateUsers(): void {
        this.currentUsers = [];

        this.usersRef.get().then((snapShot) => {
            snapShot.forEach((doc) => {
                this.currentUsers.push({id: doc.id, ...doc.data()});
            });
        });
    }

    private resetForm(): void {
        this.email = '';
        this.password = '';
        this.firstName = '';
        this.lastName = '';
    }

    private toggleEdit(item: any): void {
        this.resetForm();
        if (item) {
            this.email = item.email;
            this.firstName = item.firstName;
            this.lastName = item.lastName;
            this.currentlyEditingUserRef = item.id;
        }
        this.isEditVisible = !this.isEditVisible;
        this.isAddVisible = false;
    }

    private toggleAdd(): void {
        this.resetForm();
        this.isAddVisible = !this.isAddVisible;
        this.isEditVisible = false;
    }

    private deleteUser(item: any): void {
        alert('Cannot delete a user at this time.');
    }
}
